import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationItemInterface } from '../models/navigation-item-interface';
import { NgClass, NgTemplateOutlet, NgStyle } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-nav-item',
  styleUrls: ['./nav-item.component.scss'],
  templateUrl: './nav-item.component.html',
  imports: [NgClass, RouterLink, RouterLinkActive, NgTemplateOutlet, MatIcon, TranslateDirective, NgStyle],
})
export class NavItemComponent implements OnInit, OnDestroy {
  @HostBinding('class') public classes = 'nav-item';
  @Input() public item: NavigationItemInterface;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _fuseNavigationService = inject(FuseNavigationService);
  private _unsubscribeAll: Subject<void>;

  public constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  public ngOnInit(): void {
    // Subscribe to navigation item
    merge(
      this._fuseNavigationService.onNavigationItemAdded,
      this._fuseNavigationService.onNavigationItemUpdated,
      this._fuseNavigationService.onNavigationItemRemoved,
    )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }
}
